// src/firebaseTest.js
import { getFirestore, collection, getDocs } from "firebase/firestore";
import app from "../firebase";

const db = getFirestore(app);
async function testFirebase() {
  try {
    const querySnapshot = await getDocs(collection(db, "testCollection"));
    console.log("✅ Firebase Test connected successfully!");
    querySnapshot.forEach((doc) => console.log(doc.id, "=>", doc.data()));
  } catch (error) {
    console.error("❌ Firebase connection failed:", error);
  }
}

testFirebase();
